import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import { supabase } from './plugins/supabase'
import * as supabaseApi from './api/supabase'

Vue.use(ElementUI)
Vue.prototype.$supabase = supabase
Vue.prototype.$api = supabaseApi

Vue.config.productionTip = false

// 避免接口 404 等未捕获错误导致整页报错白屏
Vue.config.errorHandler = (err, vm, info) => {
  console.error('[Vue Error]', info, err)
}
if (typeof window !== 'undefined') {
  window.addEventListener('unhandledrejection', event => {
    if (event.reason && event.reason.response && event.reason.response.status === 404) {
      console.warn('请求 404:', event.reason.config && event.reason.config.url)
      event.preventDefault()
    }
  })
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
